// Brief 1.13/1.14: "At risk" / "Blocked" wording is suppressed. The attention
// list row carries a plain-language `reason` sentence instead of a status
// badge. `health` remains the sort key (worst-first), so all three states keep
// an entry — but the dot no longer alarms.
export const ATTENTION_HEALTH_DOTS: Record<string, string> = {
  blocked: "bg-dash-slate",
  at_risk: "bg-dash-slate",
  watching: "bg-dash-slate",
};

export const ATTENTION_HEALTH_ORDER: Record<string, number> = {
  blocked: 0,
  at_risk: 1,
  watching: 2,
};
